import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "What blogs are all about",
  "description": "",
  "published": "2008-10-25T00:00:00.000Z",
  "redirect_from": ["/blog/what-blogs-are-all-about/swizec/52"],
  "categories": "commentary",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Right now I was procrastinating blogging because there's a little something, perhaps the first proper blog entry I'll ever write, itching inside my head and I'm at girlfriend's house and her lame arse keyboard that is bent on destroying me. Well anyhow, I was clicking random tags on my blog and came upon this `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/blade-hunter/2/261"
      }}>{`entry about my funny cat`}</a>{` that I made a year ago and it made me realise what blogs are all about.`}</p>
    <p>{`You can say they're about readership, citizen journalism, monetisation, political mongreling, but the truth is they are about one thing and one thing alone - blogs are about preserving the moment, the current emotion of the world. They will one day hold the perfect time capsule of each and every day that's happened since the early 21st century. They have the unique ability of preserving not only the view of some historians, the view of some paid journalist, the view of an artist or writer, but the view of each and every one of us and in the future we will data mine the blogosphere to gather the daily, even hourly, zeitgeist of the world.`}</p>
    <p>{`Blogs show a cross-section of our society ranging from the poor mom and dad with five kids to a rich lawyer with five siblings and even that lonesome dude always reading books alone in a crowded room. Blogs ARE society!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      